import "./CheckBox.css";

const CheckBox = (props) => {
  return (
    <>
      <input
        type="checkbox"
        id={props.data_id}
        className="checkboxInput _checkbox"
        onChange={props.onChange}
        checked={props.checked}
        data_id={props.data_id}
      />
      <label for={props.data_id} className="checkboxLable ">
        <div id="tick_mark"></div>
      </label>
    </>
  );
};

export default CheckBox;
